/**
 * socket replacement component this is related to the socket
 * replacement feature allowing users not only to assign socket to empty sites (and make sites HA)
 * but also replace socket on sites
 */
mainApp.component('socketReplacement', {
    templateUrl: '/public/components/socket-replacement.component.html',
    bindings: {
        notification: '<'
    },
    controller: socketReplacementController
});

function socketReplacementController($scope,$state) {
    var ctrl = this;

    /**
     * when selecting a site with a single socket on it this are the options
     * we want to allow -
     * replace: meaning we replace the socket on the site
     * warm spare: two sockets on the site
     * @type {{REPLACE: {id: number, text: string}, WARM_SPARE: {id: number, text: string}}}
     */
    ctrl.singleSocketOptions = {
        REPLACE :{
            text: 'Replace current Socket'
        },
        WARM_SPARE:{
            text: 'Set as Warm Spare (High-Availability)'
        }
    };


    /**
     * this modes simulate a state machine according to the spec provided
     * each one has a different title and button texts
     * @type {{SELECT_SOCKET: {id: number, dialogTitle: string, approveTitle: string, cancelTitle: string}, SINGLE_SOCKET: {id: number, dialogTitle: string, approveTitle: string, cancelTitle: string}, SINGLE_SOCKET_CONFIRMATION: {id: number, dialogTitle: string, approveTitle: string, cancelTitle: string}, SINGLE_SOCKET_WARM_SPARE_CONFIRMATION: {id: number, dialogTitle: string, approveTitle: string, cancelTitle: string}, TWO_SOCKETS: {id: number, dialogTitle: string, approveTitle: string, cancelTitle: string}, TWO_SOCKET_REPLACE_CONFIRMATION: {id: number, dialogTitle: string, approveTitle: string, cancelTitle: string}}}
     */
    ctrl.modes = {
        SELECT_SOCKET:{
            dialogTitle: 'Assign Socket to a Site',
            approveTitle: 'Continue',
            cancelTitle: 'Cancel',
            approveFunction: function () {
                assignSocket2Site();
            },
            cancelFunction: function () {
                ctrl.closeDialog();
            }
        },
        SINGLE_SOCKET:{
            dialogTitle: 'Assign Socket to a Site',
            approveTitle: 'Continue',
            cancelTitle: 'Back',
            approveFunction: function () {
                if(ctrl.singleSocketSelection == ctrl.singleSocketOptions.REPLACE){
                    ctrl.mode = ctrl.modes.SINGLE_SOCKET_CONFIRMATION;
                }
                else if(ctrl.singleSocketSelection == ctrl.singleSocketOptions.WARM_SPARE){
                    ctrl.mode = ctrl.modes.SINGLE_SOCKET_WARM_SPARE_CONFIRMATION;
                }
            },
            cancelFunction: function () {
                ctrl.mode = ctrl.modes.SELECT_SOCKET;
                delete ctrl.selectedSiteOption;
                delete ctrl.singleSocketSelection;
            }
        },
        SINGLE_SOCKET_CONFIRMATION:{
            dialogTitle: 'Replace Current Socket',
            approveTitle: 'OK',
            cancelTitle: 'Back',
            approveFunction: function () {
                replaceCurrentSocket();
            },
            cancelFunction: function () {
                ctrl.mode = ctrl.modes.SINGLE_SOCKET;
            }
        },
        SINGLE_SOCKET_WARM_SPARE_CONFIRMATION:{
            dialogTitle: 'Set as Warm Spare?',
            approveTitle: 'Continue',
            cancelTitle: 'Back',
            approveFunction: function () {
                addWarmSpare();
            },
            cancelFunction: function () {
                ctrl.mode = ctrl.modes.SINGLE_SOCKET;
            }
        },
        TWO_SOCKETS:{
            dialogTitle: 'Replace a Socket?',
            approveTitle: 'Continue',
            cancelTitle: 'Back',
            approveFunction: function () {
                ctrl.mode = ctrl.modes.TWO_SOCKET_REPLACE_CONFIRMATION;
            },
            cancelFunction: function () {
                ctrl.mode = ctrl.modes.SELECT_SOCKET;
                delete ctrl.selectedSiteOption;
                delete ctrl.selectedSocket2Replace;
            }
        },
        TWO_SOCKET_REPLACE_CONFIRMATION:{
            dialogTitle: 'Replace Current Socket?',
            approveTitle: 'OK',
            cancelTitle: 'Back',
            approveFunction: function () {
                replaceCurrentSocket();
            },
            cancelFunction: function () {
                ctrl.mode = ctrl.modes.TWO_SOCKETS;
            }
        }
    };


    /**
     * for initiating the component we set default values to properties on the controller
     * and fetch data on the site
     */
    ctrl.$onInit = function() {
        ctrl.saving = false;
        ctrl.mode = ctrl.modes.SELECT_SOCKET;
        store.fetch({
            method : 'GET',
            queryParams :{
                accountId: $scope.$root.accountId,
                socketId: ctrl.notification?.SOCKET?.id
            },
            url : '/getSitesAndSockets',
            success: function(data) {
                processSocketReplacementOptions(data);
                ctrl.socketSiteOptions = data;
            },
            error: function() {
                // TODO get Alon or Avi for message
                $scope.$root.errors['socketReplacementError'] = 'Could not fetch site details';
            }
        });
    }


    /**
     * whenever we save we would like to disable the saving option from the user to
     * avoid him from re-clicking on the replace button this will disable the OK button
     */
    function preSave() {
        ctrl.saving = true;
    }

    /**
     * complete the preSave we would like to
     * @param data
     * @param msg
     */
    function postSave(data ,msg) {
        ctrl.saving = false;
        $scope.$root.handleServerResponse(data, "" , msg);
        if (data.status !== "ERROR" || data.notifications?.some(notification => notification.message.includes("This Socket is already assigned to a site"))) {
            $scope.$root.closePopup('assignSiteToSocket' + '-' + ctrl.notification.id);
            ctrl.notification.remove(ctrl.notification);
        }
    }


    /**
     * we display the socket details in a certain format we construct the text
     * on the FE so it would be faster and easy to display
     * @param data
     */
    function processSocketReplacementOptions(data) {
        data.forEach(function (siteData) {
            siteData.socketsSummery = siteData.siteName +' (';
            if(siteData.socketData.length ==0){
                siteData.socketsSummery= siteData.socketsSummery + 'no Sockets)';
            }
            else{
                siteData.socketsSummery = siteData.socketsSummery + siteData.socketData.length + ' Sockets)';
            }
        });
    }


    /**
     * assign socket to a site with no socket associated with it,
     * actually this was the only option before this component
     */
    function assignFirstSocket() {
        preSave();
        store.save({
            path: "/assignSiteToSocket",
            queryParams: {
                'siteId': ctrl.selectedSiteOption.siteId,
                'socketId': ctrl.notification.SOCKET.id
            },
            success: function(data) {
                postSave(data,'Site successfully assigned to Socket');
            }
        });
    }


    /**
     * assign socket to site will switch according to the site selected,
     * if site has no socket will just assign the socket to it, if it has
     * one socket we go to the single socket flow, if the site has two sockets
     * we go to the socket replacement flow
     */
    function assignSocket2Site() {
        if(ctrl.selectedSiteOption && ctrl.selectedSiteOption.socketData.length == 0){
            assignFirstSocket();
        }
        else if(ctrl.selectedSiteOption && ctrl.selectedSiteOption.socketData.length == 1){
            ctrl.mode = ctrl.modes.SINGLE_SOCKET;
        }
        else if(ctrl.selectedSiteOption && ctrl.selectedSiteOption.socketData.length == 2){
            ctrl.mode = ctrl.modes.TWO_SOCKETS;
            ctrl.sockets2Replace = ctrl.selectedSiteOption.socketData;
            ctrl.sockets2Replace.forEach(function (singleSocketData) {
                singleSocketData.displayName = 'S/N: '+singleSocketData.socketName + (singleSocketData.master? '(Master)':'(Backup)');
            });
        }
    }


    /**
     * a site with one socket will be added a warm spare to it
     */
    function addWarmSpare() {
        preSave();
        store.fetch({
            path: '/addWarmSpare',
            method: 'POST',
            queryParams: {
                accountId: $state.params.accountId,
                siteId: ctrl.selectedSiteOption.siteId,
                socket2AssignId: ctrl.notification.SOCKET.id
            },
            success: function (data) {
                postSave(data,'Site successfully assigned to Socket');
            }
        });
    }


    /**
     * replacing the socket selected if site has one socket we just take the first and
     * only one from the site , if the site has more then one we take the selected one
     * the server will then unassign the socket and assign the new one
     */
    function replaceCurrentSocket() {
        preSave();
        if(ctrl.selectedSiteOption.socketData.length == 1){
            var socket2ReplaceId = ctrl.selectedSiteOption.socketData[0].socketId;
        }
        else{
            var socket2ReplaceId = ctrl.selectedSocket2Replace.socketId;
        }
        store.fetch({
            path: '/replaceSocket',
            method: 'POST',
            queryParams: {
                accountId: $state.params.accountId,
                siteId: ctrl.selectedSiteOption.siteId,
                socket2AssignId: ctrl.notification.SOCKET.id,
                socket2ReplaceId: socket2ReplaceId
            },
            success: function (data) {
                postSave(data,'Socket successfully replaced');
            }
        });
    }


    /**
     * when a socket is unassign we need to reload the site
     * this event is dispatched from the socket-unassign.component
     */
    $scope.$on('socket-assign-event', function (event, data) {
        $scope.$root.openPopup('assignSiteToSocket' + '-' + ctrl.notification.id);
    });


    /**
     * close the dialog and remove the properties
     * the were or were not set during the different states
     */
    ctrl.closeDialog = function() {
        delete ctrl.selectedSiteOption;
        delete ctrl.singleSocketSelection;
        delete ctrl.selectedSocket2Replace;
        ctrl.mode = ctrl.modes.SELECT_SOCKET;
        ctrl.closePopup(ctrl.notification, 'assignSiteToSocket');
    };


    /**
     * close the pop up and remove error message if one exists
     * @param notification
     * @param elId
     */
    ctrl.closePopup = function(notification, elId) {
        delete $scope.$root.errors['socketReplacementError'];
        $scope.$root.closePopup(elId + '-' + notification.id);
    };
};

